// components/home/Home.js
import React, { useEffect, useState, useRef  } from 'react';
import './home.css';
import { Button, Form, FormControl, InputGroup } from 'react-bootstrap';
import { FaSearch, FaMobileAlt, FaRegHandPointer } from "react-icons/fa";
import axios from 'axios';

import { Link } from "react-router-dom";

const Home = () => {
  const [collections, setCollections] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const [filter, setFilter] = useState(""); // for function filter
  const inputRef = useRef(null);
 
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async () => {
    try {
      const res = await axios.get(`${API_URL}/catagory`);
      setCollections(res.data);
      setFilteredCollections(res.data);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const getButtonLink = (subcategory) => {
    if (!subcategory) return null;
    const lower = subcategory.toLowerCase();
    if (lower === "wedding") return "/typesoffunction/wedding";
    if (lower === "anniversary") return "/Anniversary";
    if (lower === "reception") return "/typesoffunction/reception";
    return null;
  };

  const getButtonLabel = (subcategory) => {
    if (!subcategory) return null;
    return subcategory.charAt(0).toUpperCase() + subcategory.slice(1);
  };

  // Handle filter change
  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);

    if (!value) {
      setFilteredCollections(collections);
      return;
    }

    const filtered = collections.filter((item) => {
      const subcategories = Array.isArray(item.subcategory)
        ? item.subcategory
        : [item.subcategory];
      return item.category.toLowerCase().includes(value.toLowerCase()) ||
             subcategories.some(sub => sub.toLowerCase().includes(value.toLowerCase()));
    });

    setFilteredCollections(filtered);
  };

  const steps = [
  {
    icon: <FaSearch size={70} />,
    title: "SEARCH",
    desc: "Get Quotations, Compare, And Book The Best Vendor For Your Wedding.",
  },
  {
    icon: <FaMobileAlt size={70} />,
    title: "SELECT",
    desc: "Select The Preferred Vendors And Send Your Requirements To Them.",
  },
  {
    icon: <FaRegHandPointer size={70} />,
    title: "BOOK",
    desc: "Get Quotations, Compare, And Book The Best Vendor For Your Wedding.",
  },
];

  return (
    <div className="wedding-home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Seamless Event Planning Starts Here</h1>
<p className="subtitle">
  VAIBHAVAM is a service by BION Technology Solution, designed to simplify your search for wedding venues and vendors.
</p>
 {/* Search Input */}
        

         
        </div>
      </section>

      {/* Dynamic Services Section */}
      <section className="services-section">
        <div className="services-content">
          <h2>Types Of Functions</h2>
          <p className="services-subtitle">
            Start planning your wedding with us, it's free!
          </p>

          <div className="service-cards">
            {filteredCollections
  .filter(item => item.category.toLowerCase() === "functions")  // filter only "Functions" category
  .map((item) => {
    const subcategories = Array.isArray(item.subcategory)
      ? item.subcategory
      : [item.subcategory];

    return (
      <div className="service-card" key={item._id}>
        <h3>{item.subcategory || "N/A"}</h3>
        {/* <p>{item.description || "N/A"}</p> */}

        {/* {subcategories.length > 0 && (
          <div className="subcategory-list">
            {subcategories.map((sub, idx) => {
              const link = getButtonLink(sub);
              const label = getButtonLabel(sub);
              return (
                <div key={idx}>
                  {link ? (
                    <Link to={link} className="action-button">
                      {label}
                    </Link>
                  ) : (
                    <span className="subcategory-label">{label}</span>
                  )}
                </div>
              );
            })}
          </div>
        )} */}

       {item.images && item.images.length > 0 && (
  <img
    src={`${API_URL}/${item.images[0]}`} // use only first image
    alt={item.name}
    style={{
      width: "100%",
      height: "auto",
      borderRadius: "8px",
      marginBottom: "10px",
    }}
  />
)}

      </div>
    );
  })}


            {filteredCollections.length === 0 && (
              <p style={{ textAlign: "center", width: "100%" }}>
                No categories found.
              </p>
            )}
          </div>
        </div>
      </section>

      <section className="how-it-works">
      <h2 className="how-title">How It Works</h2>
      <p className="how-subtitle">
        Book the Best Verified Vendors according to your requirement in 3 Simple Steps.
      </p>

      <div className="how-steps">
        {steps.map((step, index) => (
          <div className="how-card" key={index}>
            <div className="how-icon">{step.icon}</div>
            <h3 className="how-step-title">{step.title}</h3>
            <p className="how-desc">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>


    
    </div>
  );
};

export default Home;
